/* @flow */

import React, { Component } from 'react';
import Config from './config';

let filteredTimeslots;

class CalendarCell extends Component {
  onClick() {
    window.open('/schedule/#'+ this.code);
  }
  render() {
    var session = this.props.session;
    return (
      <td className="center">{session.subspecialty}<br /><span className="link" onClick={this.onClick.bind(session)}>{session.theme}</span></td>
    );
  }
}

class CalendarRow extends Component {
  render() {
    var venue = this.props.venue;
    var sessions = this.props.sessions;
    var date = this.props.date || Config.defaultDate; 

    if (sessions.length > 0) {
      var list = filteredTimeslots.map(function (timeslot) {
        var session = filterTimeslot(sessions, timeslot);
        if (session) {
          return <CalendarCell key={session.id} session={session} />;
        } else {
          return <td></td>;
        }
      });

      return (
        <tr className=""><td className="venue">{venue.name}</td>{list}</tr>
      );
    } else {
      return null;
    }
  }
}

class HeaderRow extends Component {
  render() {
    let date = this.props.date || Config.defaultDate; 
    filteredTimeslots = Config.timeslots.filter(function (timeslot) {
      return (timeslot.for.toLowerCase() === 'all' || timeslot.for === date );
    });
    let width = Math.floor(100/filteredTimeslots.length) + '%';
    var list = filteredTimeslots.map(function (timeslot) {
      return (<td width={width}>{timeslot.startTime} - {timeslot.endTime}</td>);
      // return (<td width="25%">{timeslot.startTime} - {timeslot.endTime}</td>);
    });
    return (
      <tr className="warning"><td>&nbsp;</td>{list}</tr>
    );
  }
}


export default class Calendar extends Component {
  render() {
    var sessions = this.props.sessions;
    var date = this.props.date;
    var list = Config.venues.map(function (venue) {
      var filteredSessions = filter(sessions, venue);
      return <CalendarRow key={venue.id} date={date} venue={venue} sessions={filteredSessions} />;
    });
    return (
      <table className="table table-bordered table-striped table-hover">
        <tbody>
          <HeaderRow date={date} />
          {list}
        </tbody>
      </table>
    );
  }
}

function filterTimeslot(sessions, timeslot) {
  var filteredSession;
  sessions.forEach(function (session) {
    if (session.startTime === timeslot.startTime && session.endTime === timeslot.endTime) {
      filteredSession = session;
    }
  });
  return filteredSession;
}


function filter(sessions, venue) {
  var venueName = venue.name.toLowerCase();
  var filteredSessions = [];
  sessions.forEach(function (session) {
    if (session.venue.toLowerCase() === venueName) {
      filteredSessions.push(session);
    }
  });
  return filteredSessions;
}



/** WEBPACK FOOTER **
 ** ./src/js/calendar.js
 **/